import numeral from 'numeral';

const keys = (t) => [
    {
        key: 'keyword',
        label: t('search.overview.topKeywords.keyword'),
        renderCell: ({ data }) => (
            <div>
                <a
                    href={`/domains/${window.info.id}/gsc-reports/keywords/keyword?keyword=${data}`}
                    className="d-inline-flex align-items-cente"
                    rel="noreferrer"
                >
                    {data}
                </a>
            </div>
        ),
    },
    {
        key: 'clicks',
        label: t('search.overview.topKeywords.clicks'),
        classes: 'no-wrap col',
        renderCell: ({ data }) => numeral(data).format('0.0a'),
    },
    {
        key: 'rank',
        label: t('search.overview.topKeywords.rank'),
        bar: true,
        renderCell: ({ item, allData }) => {
            let clicks = item.clicks / allData.reduce((e, f) => e + f.clicks, 0);
            return (clicks / 2) * 100;
        },
    },
];

export default keys;
